import type { OrchestratorSchemas } from '@ctcells/contract'

import { orchestrator } from '../clients.ts'
import { keys } from '../keys.ts'
import { createQuery, type SkippableArgs } from '../query.ts'

/**
 * 관리 › 설정의 정책 셋 — 조회(`IFC-RO-87` · `90` · `92` · v0.9.4).
 *
 * 실물(`ctcells-core/app/views/session_policy.py` · `settings_policy.py` · core@d50b8cf4 · dev2 실측 2026-10-12)
 *
 * | 경로 | 응답 |
 * | --- | --- |
 * | `GET /settings/session-policy` | `SessionPolicy` — `defaults`(기본값 세 칸) · `rows`(단마다 세 칸 · `null` = 그 단은 안 정함) · `roles` · `unattended_cycle_sec` |
 * | `GET /settings/security-policy` | `SecurityPolicy` — 칸마다 `{ value, default, source }` · `source` 는 `default`(전체 단에 값이 있다) · `base`(기본값) |
 * | `GET /settings/control-lock-policy` | `ControlLockPolicy` — 같은 모양 두 칸(`ttl_sec` · `heartbeat_sec`) |
 *
 * - 역할: **셋 다 admin 한정** · 제어락 비대상. 🔴 admin 이 아니면 컨테이너가 `skip` 한다(403 을 만들지 않는다).
 * - 🔴 주기 폴링 없다 — 스냅샷 1회 + 쓰기 뒤 무효화(`keys.policies.*`).
 * - 단 표기(`rows[].scope`): `default` · `role:<역할>` · `user:<user_id>`. 행 차례는 서버가 정한다(default → role → user).
 */
export type SessionPolicy = OrchestratorSchemas['schemas']['SessionPolicy']
export type SessionPolicyRow = OrchestratorSchemas['schemas']['SessionPolicyRow']
export type SessionPolicyUpdate = OrchestratorSchemas['schemas']['SessionPolicyUpdate']
export type SecurityPolicy = OrchestratorSchemas['schemas']['SecurityPolicy']
export type SecurityPolicyUpdate = OrchestratorSchemas['schemas']['SecurityPolicyUpdate']
export type ControlLockPolicy = OrchestratorSchemas['schemas']['ControlLockPolicy']
export type ControlLockPolicyUpdate = OrchestratorSchemas['schemas']['ControlLockPolicyUpdate']
/** 운영 설정 한 칸 — `{ value, default, source }` */
export type SettingValue = OrchestratorSchemas['schemas']['SettingValue']

export const useSessionPolicy = createQuery<SkippableArgs | void, SessionPolicy>({
  key: () => keys.policies.session(),
  fetch: () =>
    orchestrator.request<SessionPolicy>({ method: 'GET', path: '/settings/session-policy' }),
})

export const useSecurityPolicy = createQuery<SkippableArgs | void, SecurityPolicy>({
  key: () => keys.policies.security(),
  fetch: () =>
    orchestrator.request<SecurityPolicy>({ method: 'GET', path: '/settings/security-policy' }),
})

export const useControlLockPolicy = createQuery<SkippableArgs | void, ControlLockPolicy>({
  key: () => keys.policies.controlLock(),
  fetch: () =>
    orchestrator.request<ControlLockPolicy>({
      method: 'GET',
      path: '/settings/control-lock-policy',
    }),
})
